import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import Message from '../../../../common/Message';
import { usePageBallotCopyStyles } from '../styles';

const OnlyMessageBody = (props) => {
  const { mobile, message } = props;
  const classes = usePageBallotCopyStyles({ mobile });

  return (
    <Box className={classes.container} margin={mobile ? '0px -16px' : ''}>
      <div className={classes.msgContainer}>
        <Message severity="info" message={message} fullRounded />
      </div>
    </Box>
  );
};

OnlyMessageBody.propTypes = {
  message: PropTypes.node,
  mobile: PropTypes.bool,
};

export default OnlyMessageBody;
